var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500781,
    y: 0.500781,
    width: 53.9984,
    height: 53.9984,
    stroke: "black",
    strokeWidth: 1.00156
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8237 41.9144C24.8668 41.9144 23.4927 41.4827 21.1042 39.756C19.5933 41.6985 14.8091 43.2166 14.6004 40.6194C14.6004 38.6697 14.1687 37.0222 13.6795 35.2236C13.0968 33.0077 12.4349 30.54 12.4349 26.9644C12.4349 18.4246 19.4423 12 27.7446 12C36.0541 12 42.5651 18.7412 42.5651 27.0435C42.593 35.2175 35.9977 41.8708 27.8237 41.9144ZM27.9461 19.3815C23.9028 19.1728 20.7516 21.9715 20.0538 26.3601C19.4782 29.9933 20.4998 34.4178 21.3703 34.648C21.7876 34.7488 22.838 33.8998 23.4927 33.2451C24.5753 33.993 25.8359 34.4422 27.1475 34.5473C31.337 34.7488 34.9167 31.5594 35.198 27.3745C35.3618 23.1807 32.1361 19.6287 27.9461 19.3887V19.3815Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxIcon);
export default __webpack_public_path__ + "static/media/max-icon.54d849b5a89825eda4165932315eab9e.svg";
export { ForwardRef as ReactComponent };